// extracted by mini-css-extract-plugin
module.exports = {"CheckedRegion":"CheckedRegion_CheckedRegion__YBl4Y","showBlock":"CheckedRegion_showBlock__e5XTs","boxBtn":"CheckedRegion_boxBtn__DMAER","Btn":"CheckedRegion_Btn__wUpf7"};